import React, { useEffect, useState } from 'react';
import { reportToSegment, types } from '@smartcar/morse';
import { Tab, Tabs } from '@mui/material';
import { withRouter } from 'react-router-dom';
import { func, shape, string } from 'prop-types';

import ApplicationHeader from '../ApplicationHeader';

import staticText from '../../../../localization/Application/Logs/logs';
import RequestLogs from './components/RequestLogs';
import { TabsNav } from '../../../../global-styles/components';
import { TabPanel } from '../../../../components';
import { WebhookLogs } from './components';

// Can remove once we update TabPanel to use keys instead of index
const TAB_MAP = {
  'api-requests': 0,
  webhooks: 1,
};

const Logs = ({ location, history }) => {
  const urlParams = new URLSearchParams(location.search);
  const [currentModal, setCurrentModal] = useState(null);

  const handleTabChange = (e, newValue) => {
    urlParams.set('tab', Object.keys(TAB_MAP)[newValue] || 'api-requests');
    history.replace({
      pathname: location.pathname,
      search: urlParams.toString(),
    });
  };

  const currentTab = (urlParams.get('tab') && TAB_MAP[urlParams.get('tab')]) || 0;

  const tabPanelMap = {
    'API requests': (
      <RequestLogs setCurrentModal={setCurrentModal} />),
    Webhooks: (
      <WebhookLogs setCurrentModal={setCurrentModal} />),
  };

  useEffect(() => {
    reportToSegment(types.PAGE, 'Logs');
  }, []);

  return (
    <div style={{ maxWidth: '1600px', minWidth: '800px' }}>
      <ApplicationHeader heading={staticText.logsHeader} />
      <TabsNav color="transparent" component="nav" elevation={0}>
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
        >
          {staticText.tabs.map((tab, i) => (
            <Tab
              key={tab}
              label={tab}
              value={i}
              disableRipple
            />
          ))}
        </Tabs>
      </TabsNav>

      {staticText.tabs.map((tab, i) => (
        <TabPanel
          value={currentTab}
          index={i}
          key={`${tab}-panel-content`}
          pageName={tab}
        >
          {tabPanelMap[tab]}
        </TabPanel>
      ))}
      {currentModal}
    </div>
  );
};

export default withRouter(Logs);

Logs.propTypes = {
  location: shape({
    search: string.isRequired,
  }).isRequired,
  history: shape({
    replace: func.isRequired,
  }).isRequired,
};

